import React from "react";
import { Link } from "react-router-dom";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

import { siteData } from "../../data/siteData";

import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-start">
          {/* Company */}

          <div className="col-lg-5 col-md-12 mb-3">
            <h4 className="footer-title">Mr. Mob Fixer</h4>

            <p className="footer-description">
              Professional doorstep mobile repair service across UAE. Fast,
              reliable and affordable repairs at your location.
            </p>
          </div>

          {/* Links */}

          <div className="col-lg-3 col-md-6 mb-3 footer-links-column">
            <h5 className="footer-subtitle">Quick Links</h5>

            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <Link to="/about">About Us</Link>
              </li>

              <li>
                <Link to="/services">Services</Link>
              </li>

              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}

          <div className="col-lg-4 col-md-6 mb-3">
            <h5 className="footer-subtitle">Contact</h5>

            <div className="footer-contact">
              <p>
                <FaPhoneAlt />
                <span>{siteData.phone}</span>
              </p>

              <p>
                <FaEnvelope />
                <span>{siteData.email}</span>
              </p>

              <p>
                <FaMapMarkerAlt />
                <span>UAE</span>
              </p>
            </div>

            <a
              href={`https://wa.me/${siteData.whatsapp.replace("+", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-whatsapp"
            >
              <FaWhatsapp />
              WhatsApp Us
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} Mr. Mob Fixer. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
